export const COPY_RIGHT_INFO = {
  COMPANY_NAME: 'PureSpectrum',
  CONTACT: {
    REF: '+877865-PURE',
    LABEL: '(877) 865-PURE',
  },
};
